/**
 * BIL Store Locator DOM rendering helpers.
 */
(function (window, document) {
  'use strict';

  function escapeHtml(value) {
    return (value || '').toString()
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getElements(root) {
    return {
      root: root,
      form: root.querySelector('[data-bil-search-form]'),
      search: root.querySelector('[data-bil-search-input]'),
      state: root.querySelector('[data-bil-state-select]'),
      region: root.querySelector('[data-bil-region-select]'),
      retailer: root.querySelector('[data-bil-retailer-select]'),
      useLocation: root.querySelector('[data-bil-use-location]'),
      reset: root.querySelector('[data-bil-reset]'),
      list: root.querySelector('[data-bil-store-list]'),
      empty: root.querySelector('[data-bil-empty-state]'),
      map: root.querySelector('[data-bil-map]'),
      mapStatus: root.querySelector('[data-bil-map-status]')
    };
  }

  function optionMarkup(options, placeholder, selected) {
    return '<option value="">' + escapeHtml(placeholder) + '</option>' +
      options.map(function (value) {
        return '<option value="' + escapeHtml(value) + '"' +
          (value === selected ? ' selected' : '') + '>' + escapeHtml(value) + '</option>';
      }).join('');
  }

  function populateFilters(elements, options) {
    elements.state.innerHTML = optionMarkup(options.states, 'All states', '');
    elements.region.innerHTML = optionMarkup(options.regions, 'All markets', '');
    elements.retailer.innerHTML = optionMarkup(options.retailers, 'All retailers', '');
  }

  function formatDistance(value) {
    if (typeof value !== 'number' || !Number.isFinite(value)) return '';
    return value < 10 ? value.toFixed(1) + ' mi away' : Math.round(value) + ' mi away';
  }

  function addressMarkup(store) {
    return [
      escapeHtml(store.address_1),
      store.address_2 ? escapeHtml(store.address_2) : '',
      escapeHtml([store.city, [store.state, store.zip].filter(Boolean).join(' ')].filter(Boolean).join(', '))
    ].filter(Boolean).join('<br>');
  }

  function cardMarkup(store) {
    var distance = formatDistance(store.distance_miles);
    var directionsUrl = window.BILStoreLocatorMap.directionsUrlForStore(store);

    return '' +
      '<li class="bil-store-card" data-bil-store-card data-store-id="' + escapeHtml(store.id) + '" tabindex="0">' +
      '  <div class="bil-store-card__topline">' +
      '    <span class="bil-store-card__retailer">' + escapeHtml(store.retailer) + '</span>' +
      (distance ? '<span class="bil-store-card__distance">' + escapeHtml(distance) + '</span>' : '') +
      '  </div>' +
      '  <h3 class="bil-store-card__title">' + escapeHtml(store.store_name) + '</h3>' +
      '  <p class="bil-store-card__address">' + addressMarkup(store) + '</p>' +
      '  <div class="bil-store-card__actions">' +
      '    <button type="button" class="bil-card-button" data-action="view-map" data-store-id="' + escapeHtml(store.id) + '">View on map</button>' +
      '    <a class="bil-card-link" data-action="directions" data-store-id="' + escapeHtml(store.id) + '" href="' + directionsUrl + '" target="_blank" rel="noopener">Directions <span aria-hidden="true">↗</span></a>' +
      '  </div>' +
      '</li>';
  }

  function renderResults(elements, stores) {
    elements.list.innerHTML = stores.map(cardMarkup).join('');
    elements.empty.hidden = stores.length !== 0;
  }

  function setMapStatus(elements, message) {
    if (!message) {
      elements.mapStatus.hidden = true;
      elements.mapStatus.textContent = '';
      return;
    }
    elements.mapStatus.hidden = false;
    elements.mapStatus.textContent = message;
  }

  function setActiveCard(elements, storeId) {
    elements.list.querySelectorAll('[data-bil-store-card]').forEach(function (card) {
      card.classList.toggle('is-active', card.getAttribute('data-store-id') === storeId);
    });
  }

  window.BILStoreLocatorUI = {
    getElements: getElements,
    populateFilters: populateFilters,
    renderResults: renderResults,
    setMapStatus: setMapStatus,
    setActiveCard: setActiveCard
  };
})(window, document);
